export default (
    <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29 58C36.6913 58 44.0675 54.9447 49.5061 49.5061C54.9447 44.0675 58 36.6913 58 29C58 21.3087 54.9447 13.9325 49.5061 8.4939C44.0675 3.05535 36.6913 0 29 0C21.3087 0 13.9325 3.05535 8.4939 8.4939C3.05535 13.9325 0 21.3087 0 29C0 36.6913 3.05535 44.0675 8.4939 49.5061C13.9325 54.9447 21.3087 58 29 58ZM45.3125 29L19.9375 14.5V43.5L45.3125 29Z"
            fill="#1522B0"
        />
    </svg>
)
